import script from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiStylePanel.vue?vue&type=style&index=0&id=35c7d356&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c7d356"]])

export default __exports__